import { common as zhCommon } from './zh/common';
import { common as enCommon } from './en/common';

export const resources = {
  zh: {
    common: zhCommon
  },
  en: {
    common: enCommon
  }
} as const;